// router settings.

import Vue from 'vue';
import Router from 'vue-router';
import { systemType } from '@/config';

// main comp.
import Autoix from '@/components/Autoix';
import Login from '@/components/Login';
import Main from '@/components/Main';
import CreateDrug from '@/components/CreateDrug';
import CheckAmount from '@/components/CheckAmount';
import FetchDrug from '@/components/FetchDrug';
import SetReturnBox from '@/components/SetReturnBox';
import DrugInfo from '@/components/DrugInfo';
import RecycleDrug from '@/components/RecycleDrug';
import RefillDrug from '@/components/RefillDrug';
import RemoveOutdatedDrug from '@/components/RemoveOutdatedDrug';
import RemoveDrug from '@/components/RemoveDrug';
import UserManual from '@/components/UserManual';
import UserIndex from '@/components/UserManual/Index';
import UserBarcode from '@/components/UserManual/Barcode';
import UserPassword from '@/components/UserManual/Password';
import UserFingerprint from '@/components/UserManual/Fingerprint';
import StorageError from '@/components/StorageError';
import ReturnDrug from '@/components/ReturnDrug';
import DisabledDevices from '@/components/DisableDevicesList';
import Schedule from '@/components/Schedule';
import ScheduleReturn from '@/components/ScheduleReturn';
import FetchDrugGroup from '@/components/FetchDrugGroup';
import FetchDrugCombo from '@/components/FetchDrugCombo';
import LockBox from '@/components/LockBox';
import DrugStorageSummary from '@/components/DrugStorageSummary';
import FetchDrugSchedule from '@/components/FetchDrugSchedule';
import Waste from '@/components/Waste';
import RecycleEmpty from '@/components/RecycleEmpty';
import ReturnEmpty from '@/components/ReturnEmpty';

// admin comp.
import Admin from '@/components/Admin';
import AdminLogin from '@/components/Admin/AdminLogin';

// ADC management
import ADCManagement from '@/components/Admin/ADCManagement';
import ADCList from '@/components/Admin/ADCManagement/ADCList';
import DrugList from '@/components/Admin/ADCManagement/DrugList';
import Planning from '@/components/Admin/ADCManagement/Planning';
import PlanningList from '@/components/Admin/ADCManagement/PlanningList';
import ScheduleList from '@/components/Admin/ADCManagement/ScheduleList';
import ShiftArrange from '@/components/Admin/ADCManagement/ShiftArrange';
import FetchScheduleList from '@/components/Admin/ADCManagement/FetchScheduleList';
import CarList from '@/components/Admin/ADCManagement/CarList';
import CrossLineList from '@/components/Admin/ADCManagement/CrossLineList';
import ShoulderList from '@/components/Admin/ADCManagement/ShoulderList';

// DataImport
import DataImport from '@/components/Admin/DataImport';
import DrugImport from '@/components/Admin/DataImport/DrugImport';
import TagDrugStorageImport from '@/components/Admin/DataImport/TagDrugStorageImport';
import UserImport from '@/components/Admin/DataImport/UserImport';

// Report export
import ReportExport from '@/components/Admin/ReportExport';
import EventSummary from '@/components/Admin/ReportExport/EventSummary';
import CustomReport from '@/components/Admin/ReportExport/CustomReport';
import CrossLineReport from '@/components/Admin/ReportExport/CrossLineReport';
import ShoulderReport from '@/components/Admin/ReportExport/ShoulderReport';
import TimeLogSummary from '@/components/Admin/ReportExport/TimeLogSummary';
import IpCamTimeLogSummary from '@/components/Admin/ReportExport/IpCamTimeLogSummary';
import TimeLogAnalysis from '@/components/Admin/ReportExport/TimeLogAnalysis';
import TimeSyncSummary from '@/components/Admin/ReportExport/TimeSyncSummary';
import NTPLogSummary from '@/components/Admin/ReportExport/NTPLogSummary';
import OtherPcLogSummary from '@/components/Admin/ReportExport/OtherPcLogSummary';


// System setting
import SystemSettings from '@/components/Admin/SystemSettings';
import DrugSettings from '@/components/Admin/SystemSettings/DrugSettings';
import ControlDrugSettings from '@/components/Admin/SystemSettings/ControlDrugSettings';
import DrugGroupSettings from '@/components/Admin/SystemSettings/DrugGroupSettings';
import GeneralSettings from '@/components/Admin/SystemSettings/GeneralSettings';
import AreaSettings from '@/components/Admin/SystemSettings/AreaSettings';
import UserGroupSettings from '@/components/Admin/SystemSettings/UserGroupSettings';
import UserSettings from '@/components/Admin/SystemSettings/UserSettings';
import ComboSettings from '@/components/Admin/SystemSettings/ComboSettings';
import DrugDBSettings from '@/components/Admin/SystemSettings/DrugDBSettings';
import ParaSettings from '@/components/Admin/SystemSettings/ParaSettings';

// Tag management
import TagManagement from '@/components/Admin/TagManagement';
import TagList from '@/components/Admin/TagManagement/TagList';
import TagDrugList from '@/components/Admin/TagManagement/DrugList';
import TagPlanning from '@/components/Admin/TagManagement/Planning';
import TagPlanningList from '@/components/Admin/TagManagement/PlanningList';

//20190807 add
// Ticket management
import TicketManagement from '@/components/Admin/TicketManagement';
import CarTicketList from '@/components/Admin/TicketManagement/CarTicketList';
import CrossLineTicketList from '@/components/Admin/TicketManagement/CrossLineTicketList';
import ShoulderTicketList from '@/components/Admin/TicketManagement/ShoulderTicketList';

//20190921 add
//Confirm management
import ConfirmManagement from '@/components/Admin/ConfirmManagement';
import CarConfirmList from '@/components/Admin/ConfirmManagement/CarConfirmList';
import CrossLineConfirmList from '@/components/Admin/ConfirmManagement/CrossLineConfirmList';
import ShoulderConfirmList from '@/components/Admin/ConfirmManagement/ShoulderConfirmList';


// dev comp
import DevPanel from '@/components/Dev/DevPanel';

import store from '../vuex/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/aaaaaa',
      component: Autoix,
      redirect: { name: 'Main' },
      meta: { appType: 'cabinet' },
      children: [
        {
          path: 'main',
          name: 'Main',
          component: Main,
          meta: { appType: 'cabinet' },
        },
        {
          path: 'create-drug',
          name: 'createDrug',
          component: CreateDrug,
          meta: { appType: 'cabinet', appName: '新增藥物' },
        },
        {
          path: 'fetch-drug',
          name: 'fetchDrug',
          component: FetchDrug,
          meta: { appType: 'cabinet', appName: '一般取藥' },
        },
        {
          path: 'drug-info',
          name: 'drugInfo',
          component: DrugInfo,
          meta: { appType: 'cabinet', appName: '藥物資訊' },
        },
        {
          path: 'inventory',
          name: 'inventory',
          component: CheckAmount,
          meta: { appType: 'cabinet', appName: '盤點藥物' },
        },
        {
          path: 'set-return-box',
          name: 'setReturnBox',
          component: SetReturnBox,
          meta: { appType: 'cabinet', appName: '設定退藥盒' },
        },
        {
          path: 'return-drug',
          name: 'returnDrug',
          component: ReturnDrug,
          meta: { appType: 'cabinet', appName: '一般退藥' },
        },
        {
          path: 'recycle-drug',
          name: 'recycleDrug',
          component: RecycleDrug,
          meta: { appType: 'cabinet', appName: '回收退藥' },
        },
        {
          path: 'refill-drug',
          name: 'refillDrug',
          component: RefillDrug,
          meta: { appType: 'cabinet', appName: '補充藥物' },
        },
        {
          path: 'remove-outdated-drug',
          name: 'removeOutdatedDrug',
          component: RemoveOutdatedDrug,
          meta: { appType: 'cabinet', appName: '移除過期' },
        },
        {
          path: 'remove-drug',
          name: 'removeDrug',
          component: RemoveDrug,
          meta: { appType: 'cabinet', appName: '移除藥物' },
        },
        {
          path: 'user-manual',
          name: 'userManual',
          component: UserManual,
          redirect: { name: 'userIndex' },
          meta: { appType: 'cabinet', appName: '使用者選單' },
          children: [
            {
              path: 'index',
              name: 'userIndex',
              component: UserIndex,
              meta: { appType: 'cabinet' },
            },
            {
              path: 'barcode',
              name: 'userBarcode',
              component: UserBarcode,
              meta: { appType: 'cabinet' },
            },
            {
              path: 'password',
              name: 'userPassword',
              component: UserPassword,
              meta: { appType: 'cabinet' },
            },
            {
              path: 'fingerprint',
              name: 'userFingerprint',
              component: UserFingerprint,
              meta: { appType: 'cabinet' },
            },
          ],
        },
        {
          path: 'storage-error',
          name: 'storageError',
          component: StorageError,
          meta: { appType: 'cabinet', appName: '存量不符' },
        },
        {
          path: 'disabled-devices-list',
          name: 'disabledDevices',
          component: DisabledDevices,
          meta: { appType: 'cabinet', appName: '待維修藥盒' },
        },
        {
          path: 'schedule',
          name: 'schedule',
          component: Schedule,
          meta: { appType: 'cabinet', appName: '醫囑取藥' },
        },
        {
          path: 'schedule-return',
          name: 'scheduleReturn',
          component: ScheduleReturn,
          meta: { appType: 'cabinet', appName: '醫囑退藥' },
        },
        {
          path: 'fetch-drug-group',
          name: 'fetchDrugGroup',
          component: FetchDrugGroup,
          meta: { appType: 'cabinet', appName: '類別取藥' },
        },
        {
          path: 'fetch-drug-combo',
          name: 'fetchDrugCombo',
          component: FetchDrugCombo,
          meta: { appType: 'cabinet', appName: '套藥取藥' },
        },
        {
          path: 'fetch-drug-schedule',
          name: 'fetchDrugSchedule',
          component: FetchDrugSchedule,
          meta: { appType: 'cabinet', appName: '批次取藥' },
        },
        {
          path: 'lock-box',
          name: 'lockBox',
          component: LockBox,
          meta: { appType: 'cabinet', appName: '保險藥盒' },
        },
        {
          path: 'drugstorage-summary',
          name: 'drugStorageSummary',
          component: DrugStorageSummary,
          meta: { appType: 'cabinet', appName: '藥品統計' },
        },
        {
          path: 'waste',
          name: 'waste',
          component: Waste,
          meta: { appType: 'cabinet', appName: '拋棄藥物' },
        },
        {
          path: 'recycel-empty',
          name: 'recycleEmpty',
          component: RecycleEmpty,
          meta: { appType: 'cabinet', appName: '空瓶交換' },
        },
        {
          path: 'return-empty',
          name: 'returnEmpty',
          component: ReturnEmpty,
          meta: { appType: 'cabinet', appName: '退回空瓶' },
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { appType: 'cabinet' },
    },
    {
      path: '/',
      name: 'AdminLogin',
      component: AdminLogin,
      meta: { appType: 'admin' },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: { appType: 'admin' },
      children: [
        {
          path: 'car-management',
          name: 'ADCManagement',
          component: ADCManagement,
          redirect: { name: 'ADCList' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'adc-list',
              name: 'ADCList',
              component: ADCList,
              meta: { appType: 'admin' },
            },
            {
              path: 'drug-list',
              name: 'DrugList',
              component: DrugList,
              meta: { appType: 'admin' },
            },
            {
              path: 'car-list',
              name: 'CarList',
              component: CarList,
              meta: { appType: 'admin' },
            },
            {
              path: 'cross-line-list',
              name: 'CrossLineList',
              component: CrossLineList,
              meta: { appType: 'admin' },
            },
            {
              path: 'shoulder-list',
              name: 'ShoulderList',
              component: ShoulderList,
              meta: { appType: 'admin' },
            },
            {
              path: 'planning',
              name: 'Planning',
              component: Planning,
              meta: { appType: 'admin' },
            },
            {
              path: 'planning-list',
              name: 'PlanningList',
              component: PlanningList,
              meta: { appType: 'admin' },
            },
            {
              path: 'schedule-list',
              name: 'ScheduleList',
              component: ScheduleList,
              meta: { appType: 'admin' },
            },
            {
              path: 'shift-arrange',
              name: 'ShiftArrange',
              component: ShiftArrange,
              meta: { appType: 'admin' },
            },
            {
              path: 'fetch-schedule-list',
              name: 'FetchScheduleList',
              component: FetchScheduleList,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'tag-management',
          name: 'TagManagement',
          component: TagManagement,
          redirect: { name: 'TagList' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'tag-list',
              name: 'TagList',
              component: TagList,
              meta: { appType: 'admin' },
            },
            {
              path: 'drug-list',
              name: 'TagDrugList',
              component: TagDrugList,
              meta: { appType: 'admin' },
            },
            {
              path: 'planning',
              name: 'TagPlanning',
              component: TagPlanning,
              meta: { appType: 'admin' },
            },
            {
              path: 'planning-list',
              name: 'TagPlanningList',
              component: TagPlanningList,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'report-export',
          name: 'ReportExport',
          component: ReportExport,
          meta: { appType: 'admin' },
          redirect: { name: 'NTPLogSummary' },
          children: [
            {
              path: 'ntp-log-summary',
              name: 'NTPLogSummary',
              component: NTPLogSummary,
              meta: { appType: 'admin' },
            },
            {
              path: 'other-pc-log-summary',
              name: 'OtherPcLogSummary',
              component: OtherPcLogSummary,
              meta: { appType: 'admin' },
            },
            {
              path: 'time-log-summary',
              name: 'TimeLogSummary',
              component: TimeLogSummary,
              meta: { appType: 'admin' },
            },
            {
              path: 'time-log-analysis',
              name: 'TimeLogAnalysis',
              component: TimeLogAnalysis,
              meta: { appType: 'admin' },
            },
            {
              path: 'ipcam-time-log-summary',
              name: 'IpCamTimeLogSummary',
              component: IpCamTimeLogSummary,
              meta: { appType: 'admin' },
            },
            {
              path: 'time-sync-summary',
              name: 'TimeSyncSummary',
              component: TimeSyncSummary,
              meta: { appType: 'admin' },
            },
            {
              path: 'custom-report',
              name: 'CustomReport',
              component: CustomReport,
              meta: { appType: 'admin' },
            },
            {
              path: 'cross-line-report',
              name: 'CrossLineReport',
              component: CrossLineReport,
              meta: { appType: 'admin' },
            },
            {
              path: 'shoulder-report',
              name: 'ShoulderReport',
              component: ShoulderReport,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'data-import',
          name: 'DataImport',
          component: DataImport,
          redirect: { name: 'DrugImport' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'drug-import',
              name: 'DrugImport',
              component: DrugImport,
              meta: { appType: 'admin' },
            },
            {
              path: 'user-import',
              name: 'UserImport',
              component: UserImport,
              meta: { appType: 'admin' },
            },
            {
              path: 'tag-drug-storage-import',
              name: 'TagDrugStorageImport',
              component: TagDrugStorageImport,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'system-settings',
          name: 'SystemSettings',
          component: SystemSettings,
          redirect: { name: 'DrugSettings' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'drug-settings',
              name: 'DrugSettings',
              component: DrugSettings,
              redirect: { name: 'DrugDBSettings' },
              meta: { appType: 'admin' },
              children: [
                {
                  path: 'drug-db-settings',
                  name: 'DrugDBSettings',
                  component: DrugDBSettings,
                  meta: { appType: 'admin' },
                },
                {
                  path: 'drug-group-settings',
                  name: 'DrugGroupSettings',
                  component: DrugGroupSettings,
                  meta: { appType: 'admin' },
                },
                {
                  path: 'combo-settings',
                  name: 'ComboSettings',
                  component: ComboSettings,
                  meta: { appType: 'admin' },
                },
                {
                  path: 'control-drug-settiings',
                  name: 'ControlDrugSettings',
                  component: ControlDrugSettings,
                  meta: { appType: 'admin' },
                },
              ],
            },
            {
              path: 'user-settings',
              name: 'UserSettings',
              component: UserSettings,
              meta: { appType: 'admin' },
            },
            {
              path: 'user-group-settings',
              name: 'UserGroupSettings',
              component: UserGroupSettings,
              meta: { appType: 'admin' },
            },
            {
              path: 'general-settings',
              name: 'GeneralSettings',
              component: GeneralSettings,
              meta: { appType: 'admin' },
            },
            {
              path: 'area-settings',
              name: 'AreaSettings',
              component: AreaSettings,
              meta: { appType: 'admin' },
            },
            {
              path: 'para-settings',
              name: 'ParaSettings',
              component: ParaSettings,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'ticket-management',
          name: 'TicketManagement',
          component: TicketManagement,
          redirect: { name: 'CarTicketList' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'car-ticket-list',
              name: 'CarTicketList',
              component: CarTicketList,
              meta: { appType: 'admin' },
            },
            {
              path: 'cross-line-ticket-list',
              name: 'CrossLineTicketList',
              component: CrossLineTicketList,
              meta: { appType: 'admin' },
            },
            {
              path: 'shoulder-ticket-list',
              name: 'ShoulderTicketList',
              component: ShoulderTicketList,
              meta: { appType: 'admin' },
            },
          ],
        },
        {
          path: 'confirm-management',
          name: 'ConfirmManagement',
          component: ConfirmManagement,
          redirect: { name: 'CarConfirmList' },
          meta: { appType: 'admin' },
          children: [
            {
              path: 'car-confirm-list',
              name: 'CarConfirmList',
              component: CarConfirmList,
              meta: { appType: 'admin' },
            },
            {
              path: 'cross-line-confirm-list',
              name: 'CrossLineConfirmList',
              component: CrossLineConfirmList,
              meta: { appType: 'admin' },
            },
            {
              path: 'shoulder-confirm-list',
              name: 'ShoulderConfirmList',
              component: ShoulderConfirmList,
              meta: { appType: 'admin' },
            },
          ],
        },
      ],
    },
    {
      path: '/dev-panel',
      name: 'DevPanel',
      component: DevPanel,
      meta: { appType: 'developer' },
    },
  ],
});

// determine the system type for different router path.
router.beforeEach((to, from, next) => {
  // setup global loader
  store.commit('SHOW_LOADER', true);

  // manage the input url
  switch (to.fullPath.split('/')[1]) {
    case 'admin':
      // if user is not logined
      if (store.state.user.user === null) {
        router.push({ name: 'AdminLogin' });
      } else {
        next();
      }
      break;
    //case 'admin-login':
    case '':
      next();
      break;
    default:
      if (store.state.user.user === null) {
        router.push({ name: 'AdminLogin' });
      } else {
        next();
      }
  }
});


router.afterEach((to, from) => {
  store.commit('SHOW_LOADER', false);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js